/* Nora Janne: kleurbolletjes op productkaartjes.
   Klik = de foto van het kaartje wisselt naar die kleur (geen productpagina openen).
   Het kaartje linkt daarna naar die kleur, zodat een klik op foto of titel de juiste variant opent. */
(function () {
  function kies(bol, e) {
    var kaart = bol.closest('.grid-product, .grid__item');
    if (!kaart) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var src = bol.getAttribute('data-nj-src');
    var srcset = bol.getAttribute('data-nj-srcset');
    var mask = kaart.querySelector('.grid-product__image-mask');
    var img = mask && (mask.querySelector('.grid__image-ratio img') || mask.querySelector('.image-wrap img'));
    if (img && src) {
      img.removeAttribute('loading');
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
      kaart.classList.add('nj-kleur-gekozen');
    }
    kaart.querySelectorAll('[data-nj-kleur]').forEach(function (b) {
      b.classList.toggle('is-actief', b === bol);
      b.setAttribute('aria-pressed', b === bol ? 'true' : 'false');
    });
    var href = bol.getAttribute('href') || bol.getAttribute('data-nj-url');
    if (href) kaart.querySelectorAll('a.grid-product__link, .grid-product__image-mask a').forEach(function (a) { a.setAttribute('href', href); });
  }
  /* Sneller wisselen (Maxim 17/10): zodra iemand een kaartje aanwijst of aanraakt, laadt de browser stil de kleurfoto's
     van ALLEEN dat kaartje, in het formaat dat hij toch zou kiezen (zelfde srcset + sizes = zelfde cache).
     Niets bij het laden van de pagina, dus de pagina wordt niet trager. */
  var klaar = new WeakSet();
  function voorlaad(kaart) {
    if (!kaart || klaar.has(kaart)) return;
    klaar.add(kaart);
    try { if (navigator.connection && navigator.connection.saveData) return; } catch (e) {}
    var mask = kaart.querySelector('.grid-product__image-mask');
    var hoofd = mask && (mask.querySelector('.grid__image-ratio img') || mask.querySelector('.image-wrap img'));
    var sizes = (hoofd && hoofd.getAttribute('sizes')) || ((hoofd && hoofd.clientWidth) || 360) + 'px';
    kaart.querySelectorAll('[data-nj-kleur][data-nj-srcset]').forEach(function (bol) {
      var i = new Image();
      i.decoding = 'async';
      try { i.fetchPriority = 'low'; } catch (e) {}
      i.sizes = sizes;
      i.srcset = bol.getAttribute('data-nj-srcset');
      i.src = bol.getAttribute('data-nj-src');
      var oud = bol.getAttribute('data-variant-image');  /* foto voor het aanwijzen van het bolletje (thema) */
      if (oud) { var j = new Image(); try { j.fetchPriority = 'low'; } catch (e) {} j.src = oud; }
    });
  }
  function kaartVan(t) { return t && t.closest && t.closest('.grid-product, .grid__item'); }
  document.addEventListener('pointerover', function (e) { voorlaad(kaartVan(e.target)); }, { passive: true });
  document.addEventListener('touchstart', function (e) { voorlaad(kaartVan(e.target)); }, { passive: true });
  document.addEventListener('focusin', function (e) { voorlaad(kaartVan(e.target)); });
  /* voor Snel toevoegen: kleur kiezen = dezelfde foto als het bolletje */
  window.njKaartKleur = function (kaart, waarde) {
    var bol = Array.prototype.filter.call(kaart.querySelectorAll('[data-nj-kleur]'), function (b) { return b.getAttribute('data-nj-waarde') === waarde; })[0];
    if (!bol) return false;
    kies(bol);
    return true;
  };

  document.addEventListener('click', function (e) {
    var bol = e.target.closest && e.target.closest('.grid-product__colors [data-nj-kleur]');
    if (bol) kies(bol, e);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var bol = e.target.closest && e.target.closest('.grid-product__colors [data-nj-kleur]');
    if (bol) kies(bol, e);
  });
})();
